import { useProject } from '../project-hooks/useProject';
import { CampaignBanner } from '../../campaign-banner/CampaignBanner';
import { useSelector } from 'react-redux';
import { getEvent } from '../../event/event-reducer';
import styles from './default-event-banner.module.less';

const DefaultEventBanner = () => {
    const project = useProject();
    const event = useSelector((state) => getEvent(state, project?.event_id));

    if (!project?.event_id || !event?.id) {
        return null;
    }

    const url = !!event?.profile?.overrideBannerUrl ? event?.profile?.overrideBannerUrl : `/events/${event.id}`;

    return (
        <CampaignBanner
            className={styles.banner}
            imageUrl={event.img_url}
            text={`Spleisen er en del av`}
            linkTo={url}
            linkText={event.name || 'en event'}
        />
    );
};

export default DefaultEventBanner;
